import type { SessionDataType } from '@confluence/session-data/entry-points/SessionDataTypes.ts';

import { buildLoomMeetingsUrl } from './buildLoomMeetingsUrl.ts';

export const openLoomMeetings = ({
	cloudId,
	environment,
}: Pick<SessionDataType, 'cloudId' | 'environment'>): void => {
	globalThis.window?.open(
		buildLoomMeetingsUrl({ cloudId, environment }),
		'_blank',
		'noopener,noreferrer',
	);
};
